import React, { Suspense } from "react"
import Drawer from "@kit/design/drawer"
import { LoadingSpinner } from "@kit/design/loading-spinner"
import {
  setSubscriberProfileId,
  useSubscriberProfileId
} from "./use-subscriber-profile-id"

const SubscriberProfileDrawerContent = React.lazy(() =>
  import("./subscriber-profile-drawer-content").then(m => ({
    default: m.SubscriberProfileDrawerContent
  }))
)

export function SubscriberProfileDrawer() {
  const subscriberProfileId = useSubscriberProfileId()

  if (!subscriberProfileId) {
    return null
  }

  const onClose = () => {
    setSubscriberProfileId(null)
  }

  return (
    <Drawer onClose={onClose} label="Subscriber Profile">
      <Suspense
        fallback={
          <span role="status" aria-label="Loading subscriber profile">
            <LoadingSpinner />
          </span>
        }
      >
        <SubscriberProfileDrawerContent
          subscriberProfileId={subscriberProfileId}
        />
      </Suspense>
    </Drawer>
  )
}
